import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionIntro } from './components/SolutionIntro';
import { WhatYouGet } from './components/WhatYouGet';
import { MidCTA } from './components/MidCTA';
import { Testimonials } from './components/Testimonials';
import { AuthorSection } from './components/AuthorSection';
import { Comparison } from './components/Comparison';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { GuaranteeBadge } from './components/GuaranteeBadge';
import { Footer } from './components/Footer';
import { MobileStickyCTA } from './components/MobileStickyCTA';
export function App() {
  return <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="flex-1 pb-20 md:pb-0" data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionIntro data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <MidCTA data-id="element-7" />
        <Testimonials data-id="element-8" />
        <AuthorSection data-id="element-9" />
        <Comparison data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
        <GuaranteeBadge data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <MobileStickyCTA data-id="element-15" />
    </div>;
}